'use strict';

module.exports = require('../../functions/makeLang')({
	CHOICES: {
		Male: 'Male',
		Female: 'Female',
		Other: 'Prefer not to say'
	},
	UNKNOWN: 'Unknown gender chosen'
});
